import { Stack, Typography } from '@mui/material';
import { NoDataFound2 } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';

export const NoTreatmentDataFound = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Treatment);
  const isDesktop = useIsDesktop();

  return (
    <NoDataFound2
      gap={isDesktop ? '48px' : '32px'}
      redirects={dictionary.notEntitled.redirects}
      headerComponent={
        <Stack gap='16px' alignItems={'center'}>
          <Typography
            variant='h2'
            component='h1'
            color='text.secondary'
            alignSelf={'center'}
            tabIndex={0}
          >
            {dictionary.metaTitle}
          </Typography>
          <Stack
            alignItems={'center'}
            width={isDesktop ? '100%' : '256px'}
            textAlign={'center'}
            gap={'4px'}
            marginBottom={isDesktop ? '20px' : undefined}
          >
            <Typography
              variant='body3'
              color='text.secondary'
              marginRight={'5px'}
            >
              {dictionary.notEntitled.labels.title}
            </Typography>
            <Typography variant={'body3'} color='text.secondary'>
              {dictionary.notEntitled.labels.subtitle1}
            </Typography>
          </Stack>
        </Stack>
      }
    />
  );
};
